<template>
  <v-row density="compact">
    <p>
      The Stochastic Oscillator %K measures where the closing price sits within its N-day high/low
      range. Low readings (e.g. below 20) are oversold; high readings (above 80) are overbought.
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days"
        :items="hl_days"
        item-title="title"
        item-value="value"
        label="Lookback Window"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.above_below"
        :items="above_below"
        item-title="title"
        item-value="value"
        label="Above or Below Threshold"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="%K Threshold (0-100)"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      above_below: [
        { title: 'Above threshold (overbought)', value: 'above' },
        { title: 'Below threshold (oversold)', value: 'below' }
      ],
      hl_days: [
        { title: '1 week (5 days)', value: 5 },
        { title: '2 weeks (10 days)', value: 10 },
        { title: '3 weeks (15 days)', value: 15 },
        { title: '1 month (20 days)', value: 20 },
        { title: '50 days', value: 50 },
        { title: '90 days', value: 90 },
        { title: '6 months (125 days)', value: 125 },
        { title: '1 year (250 days)', value: 250 }
      ],
      defaultTa: {
        enabled: true,
        rule_type: 'stochastic',
        days: 20,
        above_below: 'below',
        threshold: 20,
        long_short: 'long'
      }
    }
  },

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'stochastic') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
